import debounce from 'lodash/debounce'
import throttle from 'lodash/throttle'

import Component from '../core/Component'
import EventBus from '../core/EventBus'
import { EVENTS } from '../core/Events'
import Scroll from '../services/Scroll'
import { queryAll } from '../utils/dom'

export default class SectionObserver extends Component {
    constructor(element, options = {}) {
        super(
            element,
            (options = {
                query: '[data-section-observe]',
                elements: [],
                shouldCalculateLastActiveSection: false,
                ...options,
            }),
        )

        this.ref = {
            sections: [...queryAll(this.options.query), ...this.options.elements],
        }

        this.handleThrottledScroll = throttle(this.handleScroll, 200)
        this.handleDebouncedResize = debounce(this.handleResize, 200)
        this.handleDebouncedDomChange = debounce(this.handleDomChange, 200)

        this.sections = []
    }

    prepare() {
        this.attach()
    }

    destroy() {
        this.detach()
    }

    attach() {
        this.resize()
        this.update()

        if (this.sections.length == 0) {
            return
        }

        Scroll.on('scroll', this.handleThrottledScroll)
        Scroll.on('resize-x', this.handleDebouncedResize)
        EventBus.on(EVENTS.DOM_CHANGE, this.handleDebouncedDomChange)
    }

    detach() {
        Scroll.off('scroll', this.handleThrottledScroll)
        Scroll.off('resize-x', this.handleDebouncedResize)
        EventBus.off(EVENTS.DOM_CHANGE, this.handleDebouncedDomChange)
    }

    handleDomChange = () => {
        this.resize()
        this.update()
    }

    handleResize = () => {
        this.resize()
    }

    handleScroll = () => {
        this.update()
    }

    resize() {
        const scroll = Scroll.getScroll()

        this.sections = this.ref.sections.map((section) => {
            const rect = section.getBoundingClientRect()
            return {
                element: section,
                height: rect.height,
                documentTop: rect.top + scroll.y,
            }
        })
    }

    update() {
        const sectionsInViewport = this.options.shouldCalculateLastActiveSection
            ? this.getLastActiveSectionsFromBottom()
            : this.getSectionsInViewport()

        EventBus.emit(EVENTS.SECTIONOBSERVER_SECTIONCHANGE, { sectionsInViewport })
    }

    getLastActiveSectionsFromBottom() {
        const scroll = Scroll.getScroll()
        const sectionsInViewport = []
        let lastActiveSection = null

        this.sections.forEach((section) => {
            if (scroll.y + 100 > section.documentTop) {
                lastActiveSection = section
            }
        })

        if (lastActiveSection) {
            sectionsInViewport.push(lastActiveSection)
        }

        return sectionsInViewport
    }

    getSectionsInViewport() {
        const scroll = Scroll.getScroll()
        const sectionsInViewport = []

        this.sections.forEach((section) => {
            const top = scroll.y
            const bottom = scroll.y + scroll.window.height

            //= if section is in viewport
            if (
                section.documentTop < bottom - 50 &&
                section.documentTop + section.height > top + 100
            ) {
                sectionsInViewport.push(section)
            }
        })

        //vypocet pro sortovani section podle priority => cim bliz sou k pseudocare ve vysce 1/3 viewportu, tim vetsi maj pririotu pri razeni
        sectionsInViewport.forEach((sectionInViewport) => {
            const normY = scroll.y + scroll.window.height / 3
            const diffTop = sectionInViewport.documentTop - normY
            const diffBottom = sectionInViewport.documentTop + sectionInViewport.height - normY

            sectionInViewport.norm = {
                intersecting: diffTop < 0 && diffBottom > 0,
                diff: Math.abs(Math.min(diffTop, diffBottom)),
            }
        })

        return sectionsInViewport.sort(
            (a, b) => b.norm.intersecting - a.norm.intersecting || a.norm.diff - b.norm.diff,
        )
    }
}
